import { FC } from 'react';
import cn from 'classnames';

import { PsychicLabel } from 'constants/enums';
import { getPsychicLabel } from 'src/shared/lib/psychics';
import Icon from 'src/shared/ui/Icon';
import { camalifyKebab } from 'lib/text.service';

import styles from './PsychicCardLabel.module.scss';

import { IPsychicCardLabel } from '../config/declarations';

const PsychicCardLabelSmall: FC<IPsychicCardLabel> = ({
  psychic,
  psychicFrame,
  className,
}) => {
  const labelsSprite = psychicFrame.labelsCollection?.items;
  const labelIcon = labelsSprite?.find((item) => item?.slug === 'labels-mobile');
  const slug = getPsychicLabel(psychic) || PsychicLabel.VERIFIED;

  if (!slug) {
    return null;
  }

  if (!labelIcon?.image) {
    return null;
  }

  return (
    <Icon
      image={labelIcon.image}
      className={cn(styles.iconSmall, styles[camalifyKebab(slug)], className)}
    />
  );
};

export default PsychicCardLabelSmall;
